import React, {CSSProperties, PropsWithChildren} from "react";
import {SCENE, WithScene} from "../../../interfaces/UX";

export const DOMainMenu = (props: PropsWithChildren<WithScene>) => {

    const menuStyle: React.CSSProperties = {
        display: 'flex',
        justifyContent: 'center',
        alignContent: 'center',
        flexDirection: 'column',
        textAlign: 'center',
        width: '100%',
        height: '100%',
    };

    const buttonStyle: CSSProperties = {
        display: 'inline-block',
        borderWidth: '0px',
        borderRadius: '32px',
        margin: '8px',
        backgroundColor: '#61ddff',
        width: '128px',
        height: '64px',
        textAlign: 'center',
    };

    return (
        <div style={menuStyle}>
            {/*<button style={buttonStyle} onClick={() => props.changeScene(SCENE.FLOOR_MARKER)}>Measure straight line</button>*/}
            <button style={buttonStyle} onClick={() => props.changeScene(SCENE.FLOOR_MARKER)}>Measure area</button>
        </div>
    );
};
